// source/assets/product-modal.js
if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();

        this.content = this.querySelector(".product-media-modal__content");
        this.prevButton = this.querySelector(".product-media-modal__nav-button--prev");
        this.nextButton = this.querySelector(".product-media-modal__nav-button--next");
        this.counterCurrent = this.querySelector(".product-media-modal__counter-current");
        this.currentIndex = 0;

        if (!this.content) return;

        if (this.prevButton) {
          this.prevButton.addEventListener("click", () => this.navigate(-1));
        }
        if (this.nextButton) {
          this.nextButton.addEventListener("click", () => this.navigate(1));
        }

        this.content.addEventListener("scroll", this.onScroll.bind(this), { passive: true });
        this.addEventListener("keydown", this.onKeyDown.bind(this));
        this.bindSwipe();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      get mediaItems() {
        return Array.from(this.querySelectorAll("[data-media-id]"));
      }

      showActiveMedia() {
        const mediaItems = this.mediaItems;
        if (!mediaItems.length) return;

        const openedMediaId = this.openedBy ? this.openedBy.getAttribute("data-media-id") : null;
        const activeMedia = this.querySelector(`[data-media-id="${openedMediaId}"]`) || mediaItems[0];

        this.setActive(mediaItems.indexOf(activeMedia), "auto");

        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (activeMedia.nodeName == "DEFERRED-MEDIA" && activeMediaContent && activeMediaContent.querySelector(".js-youtube"))
          activeMedia.loadContent();
      }

      navigate(direction) {
        const total = this.mediaItems.length;
        if (total < 2) return;
        this.setActive((this.currentIndex + direction + total) % total, "smooth");
      }

      // Scrolls the item into view rather than computing pixel offsets, so it
      // works before the modal has painted and whatever the item's height is.
      // block: "start" keeps the original framing for portrait media taller
      // than the viewport.
      setActive(index, behavior) {
        const mediaItems = this.mediaItems;
        if (index < 0 || index >= mediaItems.length) return;

        this.currentIndex = index;
        mediaItems.forEach((element, itemIndex) => {
          element.classList.toggle("is-active", itemIndex === index);
        });

        this.ignoreScroll = true;
        mediaItems[index].scrollIntoView({ behavior: behavior, block: "start" });
        this.updateCounter();

        clearTimeout(this.ignoreScrollTimeout);
        this.ignoreScrollTimeout = setTimeout(() => {
          this.ignoreScroll = false;
        }, behavior === "smooth" ? 600 : 100);
      }

      // The visible item is the one whose centre sits closest to the viewport
      // centre, which stays correct for mixed image/video heights.
      onScroll() {
        if (this.ignoreScroll || this.scrollFrame) return;

        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;

          const mediaItems = this.mediaItems;
          if (!mediaItems.length) return;

          const contentRect = this.content.getBoundingClientRect();
          const viewportCenter = contentRect.top + contentRect.height / 2;
          let closestIndex = 0;
          let closestDistance = Infinity;

          mediaItems.forEach((element, index) => {
            const rect = element.getBoundingClientRect();
            const distance = Math.abs(rect.top + rect.height / 2 - viewportCenter);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          if (closestIndex === this.currentIndex) return;

          this.currentIndex = closestIndex;
          mediaItems.forEach((element, index) => {
            element.classList.toggle("is-active", index === closestIndex);
          });
          this.updateCounter();
        });
      }

      updateCounter() {
        if (this.counterCurrent) this.counterCurrent.textContent = this.currentIndex + 1;
      }

      onKeyDown(event) {
        if (event.key === "ArrowRight" || event.key === "ArrowDown") {
          event.preventDefault();
          this.navigate(1);
        } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
          event.preventDefault();
          this.navigate(-1);
        }
      }

      // Horizontal swipes navigate; vertical ones are left to native scrolling.
      bindSwipe() {
        let startX = 0;
        let startY = 0;

        this.content.addEventListener(
          "touchstart",
          (event) => {
            if (event.touches.length !== 1) return;
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
          },
          { passive: true }
        );

        this.content.addEventListener(
          "touchend",
          (event) => {
            if (!event.changedTouches.length) return;
            const deltaX = event.changedTouches[0].clientX - startX;
            const deltaY = event.changedTouches[0].clientY - startY;
            if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY) * 1.5) {
              this.navigate(deltaX < 0 ? 1 : -1);
            }
          },
          { passive: true }
        );
      }
    }
  );
}
